const stationsList = {
  bindings: {
    stations: '<',
    filter: '<',
    loading: '<',
    onToggle: '&',
    onDelete: '&',
  },
  templateUrl: '/modules/pis-tool/stations/stations-list/stations-list.html',
  controller: 'StationsListController',
};

angular
  .module('pis-tool.module')
  .component('stationsList', stationsList)
  .config(function ($stateProvider) {
    $stateProvider.state('pis.workspaces.stations.list', {
      views: {
        'stationsview@pis.workspaces.stations': 'stationsList',
      },
    });
  });
